module.exports = __webpack_public_path__ + "media/images/flags/4x3/gib-da0467f23c3431fdc981aee599afc60e.svg";